import { ajaxPost, ajaxGet } from '@figure/frontlib-onboarding-redux/lib/actions/ajax';
import { baseUrl } from '@figure/frontlib-onboarding-redux/lib/actions/http-actions';

export const GET_SMS_INFO = 'GET_SMS_INFO';
export const SAVE_SMS_OPT_IN = 'SAVE_SMS_OPT_IN';
export const GET_USER_SMS_STATE = 'GET_USER_SMS_STATE';

const COMMS_CONSENT_URL = `/service-comms-prefs/secure/api/v1/consent`;
const COMMS_CONSENT_URL_EXTERNAL = `/service-comms-prefs/external/api/v1/consent`;

export const getSMSInfo = version => async dispatch =>
  ajaxGet(GET_SMS_INFO, dispatch, `${baseUrl()}${COMMS_CONSENT_URL}/prompt/SMS${version ? `?ab=${version}` : ''}`);

export const getSMSInfoExternal = version => async dispatch =>
  ajaxGet(GET_SMS_INFO, dispatch, `${baseUrl()}${COMMS_CONSENT_URL_EXTERNAL}/prompt/SMS${version ? `?ab=${version}` : ''}`);

export const saveSMSOptInOut = data => async dispatch =>
  ajaxPost(SAVE_SMS_OPT_IN, dispatch, `${baseUrl()}${COMMS_CONSENT_URL}/user`, data);

export const getUserSmsState = data => async dispatch =>
  ajaxPost(GET_USER_SMS_STATE, dispatch, `${baseUrl()}${COMMS_CONSENT_URL}/user/get`, data);
